export default __webpack_public_path__ + "images/077842739b86bdd7b0ef44f8e32d9b89.png";